// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("qwc2-icons.woff?db2aaa5c850dd3d01cfd03e4aa791e73", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "qwc2-icons";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

.icon {
	line-height: 1;
}

.icon:before {
	font-family: qwc2-icons !important;
	font-style: normal;
	font-weight: normal !important;
	vertical-align: top;
}

.icon-zoomout:before {
	content: "\\f101";
}
.icon-zoomin:before {
	content: "\\f102";
}
.icon-zoom:before {
	content: "\\f103";
}
.icon-wedge:before {
	content: "\\f104";
}
.icon-warning:before {
	content: "\\f105";
}
.icon-view:before {
	content: "\\f106";
}
.icon-up-down-arrow:before {
	content: "\\f107";
}
.icon-unpin:before {
	content: "\\f108";
}
.icon-unminimize:before {
	content: "\\f109";
}
.icon-unmaximize:before {
	content: "\\f10a";
}
.icon-undock:before {
	content: "\\f10b";
}
.icon-undock_top:before {
	content: "\\f10c";
}
.icon-undock_right:before {
	content: "\\f10d";
}
.icon-undock_left:before {
	content: "\\f10e";
}
.icon-undock_bottom:before {
	content: "\\f10f";
}
.icon-unchecked:before {
	content: "\\f110";
}
.icon-tristate:before {
	content: "\\f111";
}
.icon-triangle-up:before {
	content: "\\f112";
}
.icon-triangle-right:before {
	content: "\\f113";
}
.icon-triangle-left:before {
	content: "\\f114";
}
.icon-triangle-down:before {
	content: "\\f115";
}
.icon-tree:before {
	content: "\\f116";
}
.icon-tree_plus:before {
	content: "\\f117";
}
.icon-tree_minus:before {
	content: "\\f118";
}
.icon-trash:before {
	content: "\\f119";
}
.icon-transparency:before {
	content: "\\f11a";
}
.icon-transformtool:before {
	content: "\\f11b";
}
.icon-tools:before {
	content: "\\f11c";
}
.icon-today:before {
	content: "\\f11d";
}
.icon-tilt-up:before {
	content: "\\f11e";
}
.icon-tilt-right:before {
	content: "\\f11f";
}
.icon-tilt-left:before {
	content: "\\f120";
}
.icon-tilt-down:before {
	content: "\\f121";
}
.icon-themes:before {
	content: "\\f122";
}
.icon-text:before {
	content: "\\f123";
}
.icon-sync:before {
	content: "\\f124";
}
.icon-sunexp:before {
	content: "\\f125";
}
.icon-square:before {
	content: "\\f126";
}
.icon-sphere:before {
	content: "\\f127";
}
.icon-snap_vertex:before {
	content: "\\f128";
}
.icon-snap_edge:before {
	content: "\\f129";
}
.icon-snap_3d:before {
	content: "\\f12a";
}
.icon-share:before {
	content: "\\f12b";
}
.icon-selectbox:before {
	content: "\\f12c";
}
.icon-search:before {
	content: "\\f12d";
}
.icon-screenshot:before {
	content: "\\f12e";
}
.icon-scale:before {
	content: "\\f12f";
}
.icon-save:before {
	content: "\\f130";
}
.icon-routing:before {
	content: "\\f131";
}
.icon-routing-walking:before {
	content: "\\f132";
}
.icon-routing-truck:before {
	content: "\\f133";
}
.icon-routing-tram:before {
	content: "\\f134";
}
.icon-routing-train:before {
	content: "\\f135";
}
.icon-routing-ship:before {
	content: "\\f136";
}
.icon-routing-car:before {
	content: "\\f137";
}
.icon-routing-cablecar:before {
	content: "\\f138";
}
.icon-routing-bus:before {
	content: "\\f139";
}
.icon-routing-bicycle:before {
	content: "\\f13a";
}
.icon-report:before {
	content: "\\f13b";
}
.icon-remove:before {
	content: "\\f13c";
}
.icon-refresh:before {
	content: "\\f13d";
}
.icon-rect:before {
	content: "\\f13e";
}
.icon-rasterexport:before {
	content: "\\f13f";
}
.icon-radio_unchecked:before {
	content: "\\f140";
}
.icon-radio_tristate:before {
	content: "\\f141";
}
.icon-radio_checked:before {
	content: "\\f142";
}
.icon-pyramid:before {
	content: "\\f143";
}
.icon-print:before {
	content: "\\f144";
}
.icon-polygon:before {
	content: "\\f145";
}
.icon-point:before {
	content: "\\f146";
}
.icon-point_buffer:before {
	content: "\\f147";
}
.icon-plus:before {
	content: "\\f148";
}
.icon-plot_info:before {
	content: "\\f149";
}
.icon-pin:before {
	content: "\\f14a";
}
.icon-pick:before {
	content: "\\f14b";
}
.icon-pick_region:before {
	content: "\\f14c";
}
.icon-pick_point:before {
	content: "\\f14d";
}
.icon-person:before {
	content: "\\f14e";
}
.icon-pen:before {
	content: "\\f14f";
}
.icon-pdf:before {
	content: "\\f150";
}
.icon-paint:before {
	content: "\\f151";
}
.icon-open:before {
	content: "\\f152";
}
.icon-open_link:before {
	content: "\\f153";
}
.icon-ok:before {
	content: "\\f154";
}
.icon-oblique:before {
	content: "\\f155";
}
.icon-numericinput:before {
	content: "\\f156";
}
.icon-nodetool:before {
	content: "\\f157";
}
.icon-new:before {
	content: "\\f158";
}
.icon-nav-start:before {
	content: "\\f159";
}
.icon-nav-right:before {
	content: "\\f15a";
}
.icon-nav-left:before {
	content: "\\f15b";
}
.icon-nav-end:before {
	content: "\\f15c";
}
.icon-move:before {
	content: "\\f15d";
}
.icon-minus:before {
	content: "\\f15e";
}
.icon-minus-sign:before {
	content: "\\f15f";
}
.icon-minimize:before {
	content: "\\f160";
}
.icon-middle_v:before {
	content: "\\f161";
}
.icon-middle_h:before {
	content: "\\f162";
}
.icon-menu-hamburger:before {
	content: "\\f163";
}
.icon-measureobj:before {
	content: "\\f164";
}
.icon-measure:before {
	content: "\\f165";
}
.icon-measure_polygon:before {
	content: "\\f166";
}
.icon-measure_line:before {
	content: "\\f167";
}
.icon-maximize:before {
	content: "\\f168";
}
.icon-map3d:before {
	content: "\\f169";
}
.icon-logout:before {
	content: "\\f16a";
}
.icon-login:before {
	content: "\\f16b";
}
.icon-lock:before {
	content: "\\f16c";
}
.icon-list-alt:before {
	content: "\\f16d";
}
.icon-link:before {
	content: "\\f16e";
}
.icon-line:before {
	content: "\\f16f";
}
.icon-line_buffer:before {
	content: "\\f170";
}
.icon-light:before {
	content: "\\f171";
}
.icon-layers:before {
	content: "\\f172";
}
.icon-info:before {
	content: "\\f173";
}
.icon-info-sign:before {
	content: "\\f174";
}
.icon-import:before {
	content: "\\f175";
}
.icon-identify_region:before {
	content: "\\f176";
}
.icon-identify_radius:before {
	content: "\\f177";
}
.icon-home:before {
	content: "\\f178";
}
.icon-group:before {
	content: "\\f179";
}
.icon-freehand:before {
	content: "\\f17a";
}
.icon-folder-open:before {
	content: "\\f17b";
}
.icon-filter:before {
	content: "\\f17c";
}
.icon-fill:before {
	content: "\\f17d";
}
.icon-featureform:before {
	content: "\\f17e";
}
.icon-eye:before {
	content: "\\f17f";
}
.icon-eye-slash:before {
	content: "\\f180";
}
.icon-export:before {
	content: "\\f181";
}
.icon-expand:before {
	content: "\\f182";
}
.icon-epsilon:before {
	content: "\\f183";
}
.icon-embed:before {
	content: "\\f184";
}
.icon-ellipse:before {
	content: "\\f185";
}
.icon-editing:before {
	content: "\\f186";
}
.icon-edited:before {
	content: "\\f187";
}
.icon-editdraw:before {
	content: "\\f188";
}
.icon-draw:before {
	content: "\\f189";
}
.icon-dock:before {
	content: "\\f18a";
}
.icon-dock_top:before {
	content: "\\f18b";
}
.icon-dock_right:before {
	content: "\\f18c";
}
.icon-dock_left:before {
	content: "\\f18d";
}
.icon-dock_bottom:before {
	content: "\\f18e";
}
.icon-detach:before {
	content: "\\f18f";
}
.icon-dataimport:before {
	content: "\\f190";
}
.icon-cylinder:before {
	content: "\\f191";
}
.icon-cyclomedia:before {
	content: "\\f192";
}
.icon-cuboid:before {
	content: "\\f193";
}
.icon-copy:before {
	content: "\\f194";
}
.icon-confirm:before {
	content: "\\f195";
}
.icon-cone:before {
	content: "\\f196";
}
.icon-compare:before {
	content: "\\f197";
}
.icon-collapse:before {
	content: "\\f198";
}
.icon-cog:before {
	content: "\\f199";
}
.icon-clone:before {
	content: "\\f19a";
}
.icon-clock:before {
	content: "\\f19b";
}
.icon-clear:before {
	content: "\\f19c";
}
.icon-circle:before {
	content: "\\f19d";
}
.icon-circle_full:before {
	content: "\\f19e";
}
.icon-chevron-up:before {
	content: "\\f19f";
}
.icon-chevron-right:before {
	content: "\\f1a0";
}
.icon-chevron-left:before {
	content: "\\f1a1";
}
.icon-chevron-down:before {
	content: "\\f1a2";
}
.icon-checked:before {
	content: "\\f1a3";
}
.icon-catalog:before {
	content: "\\f1a4";
}
.icon-camera:before {
	content: "\\f1a5";
}
.icon-buffer:before {
	content: "\\f1a6";
}
.icon-box:before {
	content: "\\f1a7";
}
.icon-bookmark:before {
	content: "\\f1a8";
}
.icon-bglayer:before {
	content: "\\f1a9";
}
.icon-below:before {
	content: "\\f1aa";
}
.icon-before:before {
	content: "\\f1ab";
}
.icon-arrow-up:before {
	content: "\\f1ac";
}
.icon-arrow-down:before {
	content: "\\f1ad";
}
.icon-after:before {
	content: "\\f1ae";
}
.icon-above:before {
	content: "\\f1af";
}
.icon-above_zero:before {
	content: "\\f1b0";
}
.icon-above_terr:before {
	content: "\\f1b1";
}
.icon-3d2d:before {
	content: "\\f1b2";
}
.icon-3d:before {
	content: "\\f1b3";
}
.icon-2d:before {
	content: "\\f1b4";
}
`, "",{"version":3,"sources":["webpack://./icons/build/qwc2-icons.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,2DAA2E;AAC5E;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kCAAkC;CAClC,kBAAkB;CAClB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["@font-face {\n\tfont-family: \"qwc2-icons\";\n\tsrc: url(\"qwc2-icons.woff?db2aaa5c850dd3d01cfd03e4aa791e73\") format(\"woff\");\n}\n\n.icon {\n\tline-height: 1;\n}\n\n.icon:before {\n\tfont-family: qwc2-icons !important;\n\tfont-style: normal;\n\tfont-weight: normal !important;\n\tvertical-align: top;\n}\n\n.icon-zoomout:before {\n\tcontent: \"\\f101\";\n}\n.icon-zoomin:before {\n\tcontent: \"\\f102\";\n}\n.icon-zoom:before {\n\tcontent: \"\\f103\";\n}\n.icon-wedge:before {\n\tcontent: \"\\f104\";\n}\n.icon-warning:before {\n\tcontent: \"\\f105\";\n}\n.icon-view:before {\n\tcontent: \"\\f106\";\n}\n.icon-up-down-arrow:before {\n\tcontent: \"\\f107\";\n}\n.icon-unpin:before {\n\tcontent: \"\\f108\";\n}\n.icon-unminimize:before {\n\tcontent: \"\\f109\";\n}\n.icon-unmaximize:before {\n\tcontent: \"\\f10a\";\n}\n.icon-undock:before {\n\tcontent: \"\\f10b\";\n}\n.icon-undock_top:before {\n\tcontent: \"\\f10c\";\n}\n.icon-undock_right:before {\n\tcontent: \"\\f10d\";\n}\n.icon-undock_left:before {\n\tcontent: \"\\f10e\";\n}\n.icon-undock_bottom:before {\n\tcontent: \"\\f10f\";\n}\n.icon-unchecked:before {\n\tcontent: \"\\f110\";\n}\n.icon-tristate:before {\n\tcontent: \"\\f111\";\n}\n.icon-triangle-up:before {\n\tcontent: \"\\f112\";\n}\n.icon-triangle-right:before {\n\tcontent: \"\\f113\";\n}\n.icon-triangle-left:before {\n\tcontent: \"\\f114\";\n}\n.icon-triangle-down:before {\n\tcontent: \"\\f115\";\n}\n.icon-tree:before {\n\tcontent: \"\\f116\";\n}\n.icon-tree_plus:before {\n\tcontent: \"\\f117\";\n}\n.icon-tree_minus:before {\n\tcontent: \"\\f118\";\n}\n.icon-trash:before {\n\tcontent: \"\\f119\";\n}\n.icon-transparency:before {\n\tcontent: \"\\f11a\";\n}\n.icon-transformtool:before {\n\tcontent: \"\\f11b\";\n}\n.icon-tools:before {\n\tcontent: \"\\f11c\";\n}\n.icon-today:before {\n\tcontent: \"\\f11d\";\n}\n.icon-tilt-up:before {\n\tcontent: \"\\f11e\";\n}\n.icon-tilt-right:before {\n\tcontent: \"\\f11f\";\n}\n.icon-tilt-left:before {\n\tcontent: \"\\f120\";\n}\n.icon-tilt-down:before {\n\tcontent: \"\\f121\";\n}\n.icon-themes:before {\n\tcontent: \"\\f122\";\n}\n.icon-text:before {\n\tcontent: \"\\f123\";\n}\n.icon-sync:before {\n\tcontent: \"\\f124\";\n}\n.icon-sunexp:before {\n\tcontent: \"\\f125\";\n}\n.icon-square:before {\n\tcontent: \"\\f126\";\n}\n.icon-sphere:before {\n\tcontent: \"\\f127\";\n}\n.icon-snap_vertex:before {\n\tcontent: \"\\f128\";\n}\n.icon-snap_edge:before {\n\tcontent: \"\\f129\";\n}\n.icon-snap_3d:before {\n\tcontent: \"\\f12a\";\n}\n.icon-share:before {\n\tcontent: \"\\f12b\";\n}\n.icon-selectbox:before {\n\tcontent: \"\\f12c\";\n}\n.icon-search:before {\n\tcontent: \"\\f12d\";\n}\n.icon-screenshot:before {\n\tcontent: \"\\f12e\";\n}\n.icon-scale:before {\n\tcontent: \"\\f12f\";\n}\n.icon-save:before {\n\tcontent: \"\\f130\";\n}\n.icon-routing:before {\n\tcontent: \"\\f131\";\n}\n.icon-routing-walking:before {\n\tcontent: \"\\f132\";\n}\n.icon-routing-truck:before {\n\tcontent: \"\\f133\";\n}\n.icon-routing-tram:before {\n\tcontent: \"\\f134\";\n}\n.icon-routing-train:before {\n\tcontent: \"\\f135\";\n}\n.icon-routing-ship:before {\n\tcontent: \"\\f136\";\n}\n.icon-routing-car:before {\n\tcontent: \"\\f137\";\n}\n.icon-routing-cablecar:before {\n\tcontent: \"\\f138\";\n}\n.icon-routing-bus:before {\n\tcontent: \"\\f139\";\n}\n.icon-routing-bicycle:before {\n\tcontent: \"\\f13a\";\n}\n.icon-report:before {\n\tcontent: \"\\f13b\";\n}\n.icon-remove:before {\n\tcontent: \"\\f13c\";\n}\n.icon-refresh:before {\n\tcontent: \"\\f13d\";\n}\n.icon-rect:before {\n\tcontent: \"\\f13e\";\n}\n.icon-rasterexport:before {\n\tcontent: \"\\f13f\";\n}\n.icon-radio_unchecked:before {\n\tcontent: \"\\f140\";\n}\n.icon-radio_tristate:before {\n\tcontent: \"\\f141\";\n}\n.icon-radio_checked:before {\n\tcontent: \"\\f142\";\n}\n.icon-pyramid:before {\n\tcontent: \"\\f143\";\n}\n.icon-print:before {\n\tcontent: \"\\f144\";\n}\n.icon-polygon:before {\n\tcontent: \"\\f145\";\n}\n.icon-point:before {\n\tcontent: \"\\f146\";\n}\n.icon-point_buffer:before {\n\tcontent: \"\\f147\";\n}\n.icon-plus:before {\n\tcontent: \"\\f148\";\n}\n.icon-plot_info:before {\n\tcontent: \"\\f149\";\n}\n.icon-pin:before {\n\tcontent: \"\\f14a\";\n}\n.icon-pick:before {\n\tcontent: \"\\f14b\";\n}\n.icon-pick_region:before {\n\tcontent: \"\\f14c\";\n}\n.icon-pick_point:before {\n\tcontent: \"\\f14d\";\n}\n.icon-person:before {\n\tcontent: \"\\f14e\";\n}\n.icon-pen:before {\n\tcontent: \"\\f14f\";\n}\n.icon-pdf:before {\n\tcontent: \"\\f150\";\n}\n.icon-paint:before {\n\tcontent: \"\\f151\";\n}\n.icon-open:before {\n\tcontent: \"\\f152\";\n}\n.icon-open_link:before {\n\tcontent: \"\\f153\";\n}\n.icon-ok:before {\n\tcontent: \"\\f154\";\n}\n.icon-oblique:before {\n\tcontent: \"\\f155\";\n}\n.icon-numericinput:before {\n\tcontent: \"\\f156\";\n}\n.icon-nodetool:before {\n\tcontent: \"\\f157\";\n}\n.icon-new:before {\n\tcontent: \"\\f158\";\n}\n.icon-nav-start:before {\n\tcontent: \"\\f159\";\n}\n.icon-nav-right:before {\n\tcontent: \"\\f15a\";\n}\n.icon-nav-left:before {\n\tcontent: \"\\f15b\";\n}\n.icon-nav-end:before {\n\tcontent: \"\\f15c\";\n}\n.icon-move:before {\n\tcontent: \"\\f15d\";\n}\n.icon-minus:before {\n\tcontent: \"\\f15e\";\n}\n.icon-minus-sign:before {\n\tcontent: \"\\f15f\";\n}\n.icon-minimize:before {\n\tcontent: \"\\f160\";\n}\n.icon-middle_v:before {\n\tcontent: \"\\f161\";\n}\n.icon-middle_h:before {\n\tcontent: \"\\f162\";\n}\n.icon-menu-hamburger:before {\n\tcontent: \"\\f163\";\n}\n.icon-measureobj:before {\n\tcontent: \"\\f164\";\n}\n.icon-measure:before {\n\tcontent: \"\\f165\";\n}\n.icon-measure_polygon:before {\n\tcontent: \"\\f166\";\n}\n.icon-measure_line:before {\n\tcontent: \"\\f167\";\n}\n.icon-maximize:before {\n\tcontent: \"\\f168\";\n}\n.icon-map3d:before {\n\tcontent: \"\\f169\";\n}\n.icon-logout:before {\n\tcontent: \"\\f16a\";\n}\n.icon-login:before {\n\tcontent: \"\\f16b\";\n}\n.icon-lock:before {\n\tcontent: \"\\f16c\";\n}\n.icon-list-alt:before {\n\tcontent: \"\\f16d\";\n}\n.icon-link:before {\n\tcontent: \"\\f16e\";\n}\n.icon-line:before {\n\tcontent: \"\\f16f\";\n}\n.icon-line_buffer:before {\n\tcontent: \"\\f170\";\n}\n.icon-light:before {\n\tcontent: \"\\f171\";\n}\n.icon-layers:before {\n\tcontent: \"\\f172\";\n}\n.icon-info:before {\n\tcontent: \"\\f173\";\n}\n.icon-info-sign:before {\n\tcontent: \"\\f174\";\n}\n.icon-import:before {\n\tcontent: \"\\f175\";\n}\n.icon-identify_region:before {\n\tcontent: \"\\f176\";\n}\n.icon-identify_radius:before {\n\tcontent: \"\\f177\";\n}\n.icon-home:before {\n\tcontent: \"\\f178\";\n}\n.icon-group:before {\n\tcontent: \"\\f179\";\n}\n.icon-freehand:before {\n\tcontent: \"\\f17a\";\n}\n.icon-folder-open:before {\n\tcontent: \"\\f17b\";\n}\n.icon-filter:before {\n\tcontent: \"\\f17c\";\n}\n.icon-fill:before {\n\tcontent: \"\\f17d\";\n}\n.icon-featureform:before {\n\tcontent: \"\\f17e\";\n}\n.icon-eye:before {\n\tcontent: \"\\f17f\";\n}\n.icon-eye-slash:before {\n\tcontent: \"\\f180\";\n}\n.icon-export:before {\n\tcontent: \"\\f181\";\n}\n.icon-expand:before {\n\tcontent: \"\\f182\";\n}\n.icon-epsilon:before {\n\tcontent: \"\\f183\";\n}\n.icon-embed:before {\n\tcontent: \"\\f184\";\n}\n.icon-ellipse:before {\n\tcontent: \"\\f185\";\n}\n.icon-editing:before {\n\tcontent: \"\\f186\";\n}\n.icon-edited:before {\n\tcontent: \"\\f187\";\n}\n.icon-editdraw:before {\n\tcontent: \"\\f188\";\n}\n.icon-draw:before {\n\tcontent: \"\\f189\";\n}\n.icon-dock:before {\n\tcontent: \"\\f18a\";\n}\n.icon-dock_top:before {\n\tcontent: \"\\f18b\";\n}\n.icon-dock_right:before {\n\tcontent: \"\\f18c\";\n}\n.icon-dock_left:before {\n\tcontent: \"\\f18d\";\n}\n.icon-dock_bottom:before {\n\tcontent: \"\\f18e\";\n}\n.icon-detach:before {\n\tcontent: \"\\f18f\";\n}\n.icon-dataimport:before {\n\tcontent: \"\\f190\";\n}\n.icon-cylinder:before {\n\tcontent: \"\\f191\";\n}\n.icon-cyclomedia:before {\n\tcontent: \"\\f192\";\n}\n.icon-cuboid:before {\n\tcontent: \"\\f193\";\n}\n.icon-copy:before {\n\tcontent: \"\\f194\";\n}\n.icon-confirm:before {\n\tcontent: \"\\f195\";\n}\n.icon-cone:before {\n\tcontent: \"\\f196\";\n}\n.icon-compare:before {\n\tcontent: \"\\f197\";\n}\n.icon-collapse:before {\n\tcontent: \"\\f198\";\n}\n.icon-cog:before {\n\tcontent: \"\\f199\";\n}\n.icon-clone:before {\n\tcontent: \"\\f19a\";\n}\n.icon-clock:before {\n\tcontent: \"\\f19b\";\n}\n.icon-clear:before {\n\tcontent: \"\\f19c\";\n}\n.icon-circle:before {\n\tcontent: \"\\f19d\";\n}\n.icon-circle_full:before {\n\tcontent: \"\\f19e\";\n}\n.icon-chevron-up:before {\n\tcontent: \"\\f19f\";\n}\n.icon-chevron-right:before {\n\tcontent: \"\\f1a0\";\n}\n.icon-chevron-left:before {\n\tcontent: \"\\f1a1\";\n}\n.icon-chevron-down:before {\n\tcontent: \"\\f1a2\";\n}\n.icon-checked:before {\n\tcontent: \"\\f1a3\";\n}\n.icon-catalog:before {\n\tcontent: \"\\f1a4\";\n}\n.icon-camera:before {\n\tcontent: \"\\f1a5\";\n}\n.icon-buffer:before {\n\tcontent: \"\\f1a6\";\n}\n.icon-box:before {\n\tcontent: \"\\f1a7\";\n}\n.icon-bookmark:before {\n\tcontent: \"\\f1a8\";\n}\n.icon-bglayer:before {\n\tcontent: \"\\f1a9\";\n}\n.icon-below:before {\n\tcontent: \"\\f1aa\";\n}\n.icon-before:before {\n\tcontent: \"\\f1ab\";\n}\n.icon-arrow-up:before {\n\tcontent: \"\\f1ac\";\n}\n.icon-arrow-down:before {\n\tcontent: \"\\f1ad\";\n}\n.icon-after:before {\n\tcontent: \"\\f1ae\";\n}\n.icon-above:before {\n\tcontent: \"\\f1af\";\n}\n.icon-above_zero:before {\n\tcontent: \"\\f1b0\";\n}\n.icon-above_terr:before {\n\tcontent: \"\\f1b1\";\n}\n.icon-3d2d:before {\n\tcontent: \"\\f1b2\";\n}\n.icon-3d:before {\n\tcontent: \"\\f1b3\";\n}\n.icon-2d:before {\n\tcontent: \"\\f1b4\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
